export function showAware(to: string, opts?: { currentSlug?: string | null }) {
  const currentSlug = opts?.currentSlug?.trim()

  if (!currentSlug) {
    return to
  }

  if (!to.startsWith('/')) {
    return to
  }

  const normalizedPath = to === '/' ? '' : to

  return `/${currentSlug}${normalizedPath}`
}
